import { ChangeDetectorRef } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { TerminalSignUpViewModel } from '../../models/terminal-signup-view-model';
import { AuthenticationService } from '../../services/authentication.service';
import { PermissionEnum } from '../../services/guards/permissions';
import { ReportService } from '../../services/report.service';
import { UserDataStoreService } from '../../services/user-data-store.service';
import { ParticipantViewModel } from '../../models/participant-view-model';
import { NgSelectModule } from '@ng-select/ng-select';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-terminal-signup-report',
  templateUrl: './terminal-signup-report.component.html',
  styleUrls: ['./terminal-signup-report.component.scss']
})
export class TerminalSignupReportComponent implements OnInit {

  public raiseWarning: boolean;
  public raiseDanger: boolean;
  public hasData: boolean;
  public warning: string;
  public danger: string;
  public startDate: Date;
  public endDate: Date;

  public canView: boolean;
  public noData: string;
  public raiseNoData: boolean;
  public reportData: TerminalSignUpViewModel[] = [];
  public customers: ParticipantViewModel[] = [];
  public selectedCustomer: any = null;

  constructor(private _changeDetectorRef: ChangeDetectorRef,
    private _toastService: ToastrService,
    private _modalService: NgbModal,
    private _authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private _userDataStore: UserDataStoreService,
    private _router: Router,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _reportService: ReportService,
    private _ngxLoader: NgxUiLoaderService) {

    this.canView = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewTerminalSignUpReport]);
    this.customers = this._userDataStore.userParticipants.sort((a, b) => a.name.localeCompare(b.name));;
    let allOption: ParticipantViewModel = {
      absaO1Token: false,
      aggregatorMerchant: '',
      aggregatorSinkNode: '',
      clientId: 999999999,
      hasBankingDetails: false,
      hasCommissionDetails: false,
      hasContactDetails: false,
      hasValueAddedService: false,
      isAggregator: false,
      name: 'All',
      removePFIDetails: false,
      id:999999999
    }
    this.customers.unshift(allOption);
    debugger;
    //this.selectedCustomer = this._userDataStore.selectedParticipant.id;
    this.selectedCustomer = null;
    if (!this.canView) {
      this._toastService.warning("You do not have the required permissions to view this page, Please contact your system administrator", "Warning");
      this._router.navigate(['/']);
    }
    this.hasData = false;
  }

  ngOnInit() {

  }

  public onChange(selectedCustomer: ParticipantViewModel){
    this.selectedCustomer = selectedCustomer.id;
  }

  public async submit(): Promise<void> {

    this._ngxUiLoaderService.start();
    debugger;
    this.reportData = null;

    if (this.selectedCustomer == undefined || this.selectedCustomer <= 0) {
      this.danger = "Select Customer first.";
      this.raiseDanger = true;

    }
    else if (this.startDate == undefined && this.endDate == undefined) {
      this.raiseDanger = true;
      this.danger = "Start and End date are required";
    }
    else if (this.startDate == undefined) {
      this.raiseDanger = true;
      this.danger = "Start date is required";
    }
    else if (this.endDate == undefined) {
      this.raiseDanger = true;
      this.danger = "End date is required";
    }
    else if (this.startDate > this.endDate) {
      this.raiseDanger = true;
      this.danger = "Start date cannot be greater than End date";
    }
    else {
      debugger;
      this.reportData = await this._reportService.GetTerminalSignUpReport(this.startDate, this.endDate, this.selectedCustomer);

      if (this.reportData == null || this.reportData == undefined || this.reportData?.length == 0) {
        this.noData = "No data available.";
        this.raiseNoData = true;
        this.hasData = false;
        this.raiseDanger = false;
        this._ngxUiLoaderService.stop();
        return;
      }
      else {
        this.raiseDanger = false; 
        this.hasData = true;
        this.raiseNoData = false;
        this.noData = "";

      }
    }

    this._ngxUiLoaderService.stop();
  }

  public async exportToCSV(): Promise<void> {

    const data = this.reportData;
    const replacer = (key, value) => (value === null ? '' : value); // specify how you want to handle null values here

    const headerRow = {
      MerchantName: '',
      MerchantNumber: '',
      TerminalId: '',
      WayBill: '',
      Status: '',
      InUseBy: '',
      InUseDate: '',
      ParticipantId: '',
      SerialNumber: '',
      SimNumber: '',
      DeliveryMethod: '',
      Make: '',
      Model: '',
      BaseSerialNumber: '',
      DeviceOwnership: ''
    }

    const header = Object.keys(headerRow);

    const data1 = data.map(element => ({
      MerchantName: element.merchantName,
      MerchantNumber: element.merchantNumber,
      TerminalId: element.terminalId,
      WayBill: element.wayBill,     
      SerialNumber: element.serialNumber,
      SimNumber: element.simNumber,
      Make: element.make,
      Model: element.model,
      BaseSerialNumber: element.baseSerialNumber,
      DeviceOwnership: element.deviceOwnership,
      Status: element.status,
      InUseBy: element.inUseBy,
      InUseDate: element.inUseDate,
      ParticipantId: element.participantId,
      DeliveryMethod: element.deliveryMethod,  
    }))

    const csv = data1.map((row) =>
      header
        .map((fieldName) => JSON.stringify(row[fieldName], replacer))
        .join(',')
    );


    csv.unshift(header.join(','));
    const csvArray = csv.join('\r\n');

    const a = document.createElement('a');
    const blob = new Blob([csvArray], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    var fileName = 'Device_Request_Report_' + this.startDate + '_' + this.endDate + '_.csv';
    a.href = url;
    a.download = (fileName);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }


  public async reset(): Promise<void> {
    this._ngxUiLoaderService.start();

    this.ClearTable();
    this.hasData = false;

    this._ngxUiLoaderService.stop();

  }

  public async ClearTable(): Promise<void> {

    this.reportData = [];
    const bankTransDiv = document.querySelector("div.bankTransactions"); // Find the bankTransaction div in our HTML

    while (bankTransDiv.firstChild) {
      bankTransDiv.removeChild(bankTransDiv.firstChild); //Remove all children from table div (if any)
    }
  }

  public async onCustomerChange(): Promise<void> {
  
    this._ngxLoader.start();
    await this._authenticationService.refreshSession(this.customers.find(x => x.id == this.selectedCustomer).id);
    await this._router.navigate(['topbarComponent', 'topbar']);
    await this._router.navigate(['']);
    this._ngxLoader.stop();
    
  }


}
